<div class="modal1Main defaultPop">
    <div class="modalHeader">
        <span class="title">
            New Message
        </span>
        <button class="closepop float-right" mat-dialog-close><i class="zmdi zmdi-close"></i></button>
    </div>
    <form [formGroup]="messageForm" (ngSubmit)="sendMessage()">
        <div class="defaultPopCont">
            <div class="mB20">
                <mat-form-field class="form-control width100" >
                    <mat-select formControlName="friends" placeholder="Select Friends" multiple>
                        <mat-option *ngFor="let rec of friendList;let i = index" [value]="rec?.id" >{{rec?.drafters_id}}</mat-option> 
                    </mat-select>
                </mat-form-field>
            </div>
            <div #emojiDiv class="cretaeNewMsg"> 
                <input type="text" formControlName="temp_message" id="postDraftMessage3" placeholder="Write a message..." data-emojiable="true"  autocomplete="off"> 
            </div>
        </div>
        <div class="text-center defaultPopfoot">
            <button mat-raised-button color="primary" class="joinDraftBtn">Send</button>  
        </div> 
    </form>
</div>
    